import React, { useCallback } from "react";

import { RemoveConfirmation } from "modules/common/components/form/RemoveConfirmation";
import { texts } from "modules/common/texts";
import { TreeNodeInfo } from "@blueprintjs/core";
import { Prompt } from "modules/common/components/form/Prompt";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import styles from "./FileSystemPage.module.scss";

export const FileActions = ({ file, remove, canManage, rename, download: save }: FileActionsProps) => {
    const download = useCallback(() => {
        file && save(file.id as string);
    }, [file, save]);

    const onRename = useCallback(
        (name: string) => {
            file && rename(name, file.id as string);
        },
        [file, rename]
    );

    return (
        <div className={styles.folderBtns}>
            {file && (
                <PlanrButton type="graybtn" icon={"general-download"} onClick={download} round={true} title="Скачать" />
                // <div title={texts.download} onClick={download}>
                //     <Icon icon="download" />
                // </div>
            )}
            {file && canManage && (
                <Prompt
                    what="Новое название файла"
                    onConfirmed={onRename}
                    render={({ ask }) => (
                        <PlanrButton
                            type="graybtn"
                            icon={"general-edit"}
                            onClick={() => ask(file.label as string)}
                            round={true}
                            title="Переименовать"
                        />
                        // <div title="Переименовать" onClick={() => ask(file.label as string)}>
                        //     <Icon icon="edit" />
                        // </div>
                    )}
                />
            )}
            {file && canManage && (
                <RemoveConfirmation<TreeNodeInfo<NodeData>>
                    what={(f) => {
                        const prefix =
                            f.nodeData && f.nodeData.version > 1 ? `${f.nodeData.version} версию файла` : "файл";
                        return `${prefix} ${f.label}`;
                    }}
                    onConfirmed={(f) => remove(f.id as string)}
                    render={({ confirmRemoving }) => {
                        return (
                            <PlanrButton
                                type="graybtn"
                                icon={"general-trash"}
                                onClick={() => confirmRemoving(file)}
                                round={true}
                                title={texts.remove}
                            />
                            // <div title={texts.remove} onClick={() => confirmRemoving(file)}>
                            //     <Icon icon='trash' />
                            // </div>
                        );
                    }}
                />
            )}
        </div>
    );
};

/**
 * Данные узла дерева — только простые значения. Сам файл (узел MST) берётся из
 * стора по id узла: `load()` пересоздаёт узлы через `applySnapshot`, и ссылка на
 * прежний узел в дереве была бы ссылкой на мёртвый узел. React 19 в dev разбирает
 * сменившиеся пропсы `TreeNode` вглубь, трогает его ленивые поля — MST бросает
 * проверку из фазы коммита, и навигация замирает. См. рабочий элемент #27.
 */
export interface NodeData {
    version: number;
}

interface FileActionsProps {
    canManage: boolean;
    file: TreeNodeInfo<NodeData> | null;
    remove: (id: string) => void;
    rename: (name: string, id: string) => void;
    download: (id: string) => void;
}
